// extracted by mini-css-extract-plugin
export var button = "_jn-2";
export var card = "_jn-0";
export var closeButtonContainer = "_jn-3";
export var iconContainer = "_jn-1";